import React, { createContext, useReducer } from 'react'

export const SET_FUNCTIOANAL_MAPPING_SEARCH_DATA =
  'SET_FUNCTIOANAL_MAPPING_SEARCH_DATA'
export const SET_SELECTED_SECTION_DATA = 'SET_SELECTED_SECTION_DATA'
export const SET_SELECTED_SECTION_RECORD_DATA =
  'SET_SELECTED_SECTION_RECORD_DATA'
export const SET_SEARCHING_STATUS = 'SET_SEARCHING_STATUS'
export const SET_CIRCUIT_PINS = 'SET_CIRCUIT_PINS'
export const SET_RELATED_CONNECTORS = 'SET_RELATED_CONNECTORS'
export const RESET_CIRCUIT_PINS = 'RESET_CIRCUIT_PINS'
export const SET_CONNECTOR_TAB = 'SET_CONNECTOR_TAB'
export const SET_MAPPED_CONNECTORS = 'SET_MAPPED_CONNECTORS'
export const SELECT_DESELECT_CONNECTORS = 'SELECT_DESELECT_CONNECTORS'
export const SET_FUNCTIONAL_DIAGRAM_DETAILS = 'SET_FUNCTIONAL_DIAGRAM_DETAILS'
export const RESET_SELECTED_CONNECTORS = 'RESET_SELECTED_CONNECTORS'
export const SELECT_DESELECT_CONNECTOR_CATEGORIS =
  'SELECT_DESELECT_CONNECTOR_CATEGORIS'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_FUNCTIOANAL_MAPPING_SEARCH_DATA: {
      return {
        ...data,
        data: payload.data.data,
        selectedSection: payload.data.selectedSection,
        selectedCircuitPins: [],
        isSearching: false,
        selectedConnectorCategories: [],
        selectConnectors: {
          ...data.selectConnectors,
          current: 'mapped',
          pending: [],
        },
        selectedSectionRecord: { data: [] },
      }
    }
    case SET_SELECTED_SECTION_DATA: {
      return {
        ...data,
        selectedSection: payload.data,
        selectedCircuitPins: [],
        selectConnectors: {
          ...data.selectConnectors,
          current: 'mapped',
          pending: [],
        },
        selectedSectionRecord: { data: [] },
        selectedConnectorCategories: [],
      }
    }
    case SET_SELECTED_SECTION_RECORD_DATA: {
      return {
        ...data,
        selectedSectionRecord: payload.data,
        selectedCircuitPins: [],
        selectConnectors: {
          ...data.selectConnectors,
          current: 'mapped',
          pending: [],
        },
        selectedConnectors: [],
        selectedConnectorCategories: [],
        startConnectors: [],
      }
    }
    case SET_SEARCHING_STATUS: {
      return { ...data, isSearching: payload.data }
    }
    case SET_CIRCUIT_PINS: {
      let selected_pins = [...data.selectedCircuitPins]
      if (selected_pins.includes(payload.data)) {
        selected_pins = selected_pins.filter((item) => item !== payload.data)
      } else {
        selected_pins.push(payload.data)
      }

      let tempStartConnectors = [...data.startConnectors]
      if (!tempStartConnectors.includes(payload.startConnectors)) {
        tempStartConnectors.push(payload.startConnectors)
      }
      return {
        ...data,
        selectedCircuitPins: selected_pins,
        relatedConnectors: [],
        startConnectors: tempStartConnectors,
      }
    }
    case RESET_CIRCUIT_PINS: {
      return {
        ...data,
        selectedCircuitPins: [],
        selectConnectors: {
          ...data.selectConnectors,
          current: 'mapped',
          pending: [],
        },
        selectedConnectors: [],
        selectedConnectorCategories: [],
      }
    }
    case SET_CONNECTOR_TAB: {
      return {
        ...data,
        selectConnectors: { ...data.selectConnectors, current: payload.data },
        selectedConnectors: [],
      }
    }
    case SET_MAPPED_CONNECTORS: {
      return {
        ...data,
        selectConnectors: { ...data.selectConnectors, mapped: payload.data },
      }
    }
    case SET_RELATED_CONNECTORS: {
      return {
        ...data,
        selectConnectors: {
          ...data.selectConnectors,
          current: 'pending',
          pending: payload.data,
        },
      }
    }
    case SELECT_DESELECT_CONNECTORS: {
      let selected_connectors = [...data.selectedConnectors]
      if (selected_connectors.includes(payload.data)) {
        selected_connectors = selected_connectors.filter(
          (item) => item !== payload.data
        )
      } else {
        selected_connectors.push(payload.data)
      }
      return {
        ...data,
        selectedConnectors: selected_connectors,
      }
    }
    case RESET_SELECTED_CONNECTORS: {
      return {
        ...data,
        selectedConnectors: [],
      }
    }
    case SET_FUNCTIONAL_DIAGRAM_DETAILS: {
      return {
        ...data,
        functionalDiagramDetails: payload.data,
        selectConnectors: {
          ...data.selectConnectors,
          mapped: payload.mappedConnector,
        },
        connectorCategories: payload.connectorCategories,
      }
    }
    case SELECT_DESELECT_CONNECTOR_CATEGORIS: {
      let selected_connector_categories = [...data.selectedConnectorCategories]
      if (selected_connector_categories.includes(payload.data)) {
        selected_connector_categories = selected_connector_categories.filter(
          (item) => item !== payload.data
        )
      } else {
        selected_connector_categories.push(payload.data)
      }
      return {
        ...data,
        selectedConnectorCategories: selected_connector_categories,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: { connectors: [], devices: [], circuits: [] },
  selectedSection: { data: [], type: 'connectors' },
  selectedSectionRecord: { data: [] },
  isSearching: false,
  selectedCircuitPins: [],
  relatedConnectors: [],
  selectConnectors: { mapped: [], pending: [], current: 'mapped' },
  selectedConnectors: [],
  functionalDiagramDetails: {},
  connectorCategories: [],
  selectedConnectorCategories: [],
  startConnectors: [],
}

const FunctionalDiagramEditStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <FunctionalDiagramEditContext.Provider value={[state, dispatch]}>
      {children}
    </FunctionalDiagramEditContext.Provider>
  )
}

export const FunctionalDiagramEditContext = createContext(initialState)
export default FunctionalDiagramEditStore
